import React, { useState, useEffect } from "react";
import { useCamera } from "./captureCamera";
import Button from "@mui/material/Button";

/**
 * Functional component with modern React hooks
 */
function FullScreenMobileView({ cameraPic, cancelPic }) {
  // Calculate initial width/height based on screen size
  const initialWidth =
    window.screen.width > 1200 ? 600 : window.screen.width;
  const initialHeight =
    window.screen.width > 1200
      ? window.screen.height * 0.8
      : window.screen.height * 0.5;

  // Local state
  const [width] = useState(initialWidth);
  const [height] = useState(initialHeight);
  const [imageDatas, setImageDatas] = useState([]);

  // Custom hook for camera
  const { captureImage, imageData } = useCamera();

  /**
   * Whenever `imageData` changes (e.g. after a capture),
   * add it to our array. (If `imageData` is a base64 string.)
   */
  useEffect(() => {
    if (imageData) {
      setImageDatas((prev) => [...prev, imageData]);
    }
  }, [imageData]);

  /**
   * Takes a snapshot using `captureImage()`, then converts
   * the base64 result to a Blob, calls `cameraPic(blobPic)`,
   * and stops the camera stream.
   */
  const takePicture = async () => {
    try {
      const capturedPic = await captureImage(); // base64 string

      // Convert base64 -> Blob
      const [prefix, base64Part] = capturedPic.split(",");
      const mimeMatch = prefix.match(/:(.*?);/);
      const mime = mimeMatch ? mimeMatch[1] : "image/png";

      const binary = atob(base64Part);
      const n = binary.length;
      const u8arr = new Uint8Array(n);
      for (let i = 0; i < n; i++) {
        u8arr[i] = binary.charCodeAt(i);
      }
      const blobPic = new Blob([u8arr], { type: mime });

      // Stop the video track
      const video = document.getElementsByTagName("video")[0];
      if (video && video.srcObject) {
        video.pause();
        const [track] = video.srcObject.getVideoTracks();
        if (track) track.stop();
      }

      // Pass the blob to parent
      cameraPic(blobPic);
    } catch (err) {
      console.error("Error capturing image:", err);
    }
  };

  return (
    <div className="cameraModal">
      <div className="cameraInnerDiv" style={{ width }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "flex-start"
          }}
        >
          <div className="VideoAndCanvas">
            <video
              width={width}
              height={height}
              style={{ objectFit: "contain" }}
            />
            <canvas
              width={width}
              height={height}
              style={{ opacity: 0 }}
            />
          </div>

          <div
            className="cameraCaptureButtons"
            style={{ width: width * 0.5 }}
          >
            <Button
              variant="contained"
              color="primary"
              className="ButtonShadow"
              onClick={takePicture}
            >
              Capture
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className="ButtonShadow"
              onClick={cancelPic}
            >
              Cancel
            </Button>
          </div>

          {imageDatas.length > 0 && (
            <div
              id="Images"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                flexWrap: "wrap",
                margin: "1%",
                padding: "1%"
              }}
            >
              {imageDatas.map((data, index) =>
                data.length > 10 ? ( // skip empty or invalid data strings
                  <img
                    key={index}
                    src={data}
                    width={width * 0.45}
                    alt="NoImage"
                  />
                ) : null
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default FullScreenMobileView;
